import { useOutletContext } from "react-router-dom";

import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/footer/footer";

import GetComponentsFromBloks from "../../helpers/bloksRenderer";
import { Helmet } from "react-helmet";
import { FormattedMessage, useIntl } from "react-intl";
import PageContentWrapper from "../../components/PageContentWrapper";

function PageLayout() {
  const intl = useIntl();
  const { story } = useOutletContext();

  let componentList = [];

  if (story && story.content && story.content.body) {
    componentList = GetComponentsFromBloks(story.content.body, story);
  }

  return (
    <>
      <Helmet>
        <title>{intl.formatMessage({ id: "seo.title" })}</title>
        <meta
          name="description"
          content={intl.formatMessage({ id: "seo.description" })}
        />
      </Helmet>
      <Navbar story_language={story.lang} />
      <PageContentWrapper>
        <div className="page-content">{componentList}</div>
      </PageContentWrapper>
      <Footer />
    </>
  );
}

export default PageLayout;
